export default __webpack_public_path__ + "static/media/FoodStore_06.6859f3f0.png";